export const forwardingCopy = {
  warningOff: '',
  warningOn: '',
  title: '',
  description: '',
};
